<div class="reset-using-opts-field" *ngIf="resetPassword">
  <h5 class="continue-text">Reset Password Using</h5>
  <div class="login-tabs">
    <ul class="nav nav-tabs mb-3" id="ex3" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link" 
          (click)="showMobileNumberTab()"
          [class.active]="isMobileNumberTabActive"
          aria-controls="ex1-tabs-1-login"
          aria-selected="true"
          >Mobile Number</a
        >
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          (click)="showEmailTab()"
          [class.active]="isEmailTabActive"
          aria-controls="ex1-tabs-2-login"
          aria-selected="false"
          >E-Mail</a
        >
      </li>
    </ul>
    <div class="sign-in-popup-dtls tab-content mt-4" id="ex1-content-login">
      <form [formGroup]="myForm" disabledAutocomplete (ngSubmit)="sentOTP(myForm)">
        <div class="form-floating login-via-email" *ngIf="isEmailTabActive">
          <input
            type="email" formControlName="email"
            class="form-control"
            id="floatingInput"
            placeholder="name@example.com"
            disabledAutocomplete
          />
          <label for="floatingInput">Email ID *</label>
        </div>
        <div class="form-floating login-via-number" *ngIf="isMobileNumberTabActive">
          <input type="number" class="form-control" id="countryCode" formControlName="mobile" placeholder=" " #countryCodeInput/>
          <label for="countryCode">Mobile Number *</label>
          <div class="custom-dropdown">
            <input [value]="selectedCountryCode" class="selected-input-code-filed" autocomplete="off" autocorrect="off"
              (click)="toggleDropdown($event)" autocapitalize="none" spellcheck="false" />
            <div class="dropdown-content" [ngClass]="{ open: isOpen }">
              <div class="search-via-input-code">
                <input class="search-dropdown_dropdown_search" type="text" placeholder="Search"
                  formControlName="searchText" (keyup)="search()" />
              </div>
              <div *ngFor="let code of countryCodes" (click)="toggleDropdown($event)">
                <div (click)="toggleDropdown($event);countryCodeSelect(code,$event)">
                  <span>{{ code.isd_code }}</span> ({{ code.country_en }})
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="create-account-note" *ngIf="isMobileNumberTabActive">Please enter the mobile number that was used to create your Rehlaty account</p>
        <p class="create-account-note" *ngIf="isEmailTabActive">Please enter the email-id that was used to create your Rehlaty account</p>
        <div class="sign-in-btn">
          <button class="mt-0 mb-2" type="submit" >Continue</button>
        </div>
      </form>
    </div>
    <span
      >Remember Password ?
      <a (click)="clickHandler()">Sign In</a></span
    >
  </div>
</div>

<div *ngIf="isOTPSend" class="otp-sent-main-div login-tabs">
  <div class="successfully-sent-otp">
    <img src="/assets/image/otp-send.gif" alt="">
    <h4>The activation code has been sent
      to the {{otpSentText}}</h4>
  </div>
</div>

<div class="enter-otp-inputs forgot-pass-filds login-tabs" *ngIf="enterOTP">
  <div class="otps-fileds">
    <form action="" disabledAutocomplete>
      <input #inputA type="text" maxlength="1" (input)="onInputChange(inputA)" autofocus />
      <input #inputB type="text" maxlength="1" (input)="onInputChange(inputB)" />
      <input #inputC type="text" maxlength="1" (input)="onInputChange(inputC)" />
      <input #inputD type="text" maxlength="1" (input)="onInputChange(inputD)" />
      <input #inputE type="text" maxlength="1" (input)="onInputChange(inputE)" />
      <input #inputF type="text" maxlength="1" (input)="onInputChange(inputF)" />
    </form>
    <p class="create-account-note mt-4">Please enter the OTP we have shared on <br>
      <b>{{otpSentOnText}}</b>
    </p>
    <a (click)="sendVerificationOTP()">Resend</a>
      <div class="sign-in-btn tanish" (click)="verifyOTP()">
        <button class="mt-0 mb-2">Continue</button>
      </div>
  </div>
</div>

<div class="enter-otp-inputs forgot-pass-filds login-tabs" *ngIf="setNewPassword">
    <form [formGroup]="myFormPassword" disabledAutocomplete (ngSubmit)="ResetPassword(myFormPassword)">
      <div class="form-floating mt-2">
        <input
          type="password" formControlName="password"
          class="form-control floatingPassword"
          id="floatingPassword"
          [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="Password"
          required
          disabledAutocomplete
        />
        <label for="floatingPassword">New Password</label>
        <div class="input-group-append">
          <span class="input-group-text" (click)="togglePasswordVisibility()">
            <i class="fas fa-eye show_eye" *ngIf="!isPasswordVisible"></i>
            <i class="fas fa-eye-slash hide_eye" *ngIf="isPasswordVisible"></i>
          </span>
        </div>
      </div>
      <div class="form-floating mt-2">
        <input
          type="password" formControlName="confirmPassword"
          class="form-control floatingPassword"
          id="floatingConfirmPassword"
          [type]="isPasswordVisibleConfirm ? 'text' : 'password'"
          placeholder="Password"
          required
          disabledAutocomplete
        />
        <label for="floatingPassword">Confirm New Password</label>
        <div class="input-group-append">
          <span class="input-group-text" (click)="togglePasswordVisibilityConfirm()">
            <i class="fas fa-eye show_eye" *ngIf="!isPasswordVisibleConfirm"></i>
            <i class="fas fa-eye-slash hide_eye" *ngIf="isPasswordVisibleConfirm"></i>
          </span>
        </div>
      </div>
    
      <p class="create-account-note mt-4">
          <span>The password must be of minimum {{pwdMinLength}} character length, including </span>
          <span *ngIf="pwdPsecialCharLength > 0">{{pwdPsecialCharLength}} Special Characters, </span>
          <span *ngIf="pwdAlphaNumericharLength > 0">{{pwdAlphaNumericharLength}} Alphanumeric Characters, </span>
          <span *ngIf="pwdUpperCaseLength > 0">{{pwdUpperCaseLength}} Uppercase Characters, </span>
          <span *ngIf="pwdLowerCaseLength > 0">{{pwdLowerCaseLength}} Lowercase Characters, </span>
          <span *ngIf="pwdNumericCharLength > 0">{{pwdNumericCharLength}} Numeric Characters</span> 
      </p>
       <div class="sign-in-btn">
         <button type="submit" class="mt-0 mb-2">Continue</button>
       </div>
      </form>
</div>